"use strict";

define('components/document_details_edit',[], function() {
    /*
     * Contains logic specific to the edit-details module for documents.
     */

    return {
        init: function (node) {
            /**
             * Displays or hides the recipients-log-in-warning banner when requires_login checkbox is checked
             */
            var showHideLogInWarning = function () {
                if ($('input[name="requires_login"]').is(":checked")) {
                $("#recipients-log-in-warning").show();
                } else {
                $("#recipients-log-in-warning").hide();
                }
            };
            // Show or hide the initial login warning
            showHideLogInWarning();
            // When changing the document category, update the (dependent) form input 'requires_login'
            node.find('select[name="document_category_id"]').change(function(e) {
                if ($(this).find('option:selected').data('requires-login') == 'True') {
                    node.find('input[name="requires_login"]')
                        .attr('disabled', 'disabled')
                        .prop('checked', 'checked');
                    var desc = node.find('input[name="requires_login"]').data('cat-requires-login-desc');
                } else {
                    node.find('input[name="requires_login"]')
                        .attr('disabled', false)
                        .prop('checked', false);
                    var desc = node.find('input[name="requires_login"]').data('doc-requires-login-desc');
                }
                // When we update document category, we need to re-check to show warning
                showHideLogInWarning();
                node.find(".requires-login .small-text").text(desc);
            });

            // When clicking the require log in checkbox, display/hide the warning banner
            node.find('input[name="requires_login"]').click(function (e) {
                showHideLogInWarning();
            });

            node.find('[name="watermark_id"]').change(function() {
                var id = parseInt($(this).val(), 10);
                if (id) {
                    var first_watermark_hidden = node.find('#select-first-page-watermark').hasClass('hidden');
                    node.find('#select-has-separate-first-page-watermark').toggleClass('hidden', !first_watermark_hidden);
                } else {
                    node.find('[name="first_page_watermark_id"]').val('0');
                    node.find('#select-first-page-watermark').addClass('hidden');

                    node.find('[name="has_separate_first_page_watermark"]').prop('checked', false);
                    node.find('#select-has-separate-first-page-watermark').addClass('hidden');

                    node.find("#watermark-singular-wrapper").append(node.find('[name="watermark_id"]'));
                }
            });
            node.find('[name="has_separate_first_page_watermark"]').change(function() {
                node.find('#select-has-separate-first-page-watermark').addClass('hidden');
                node.find('#select-first-page-watermark').removeClass('hidden');
                node.find("#watermark-subsequent-pages-wrapper").append(node.find('[name="watermark_id"]'));
            });
        }
    };

});

